import o from "./index820.js";
var t = function() {
  return o.Date.now();
};
export {
  t as default
};
